import type { PuzzleMode } from '../../engine/types';
import { ThornBoard } from './Board';
import {
  THORN_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  hint,
  moveFeedback,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type ThornConfig,
  type ThornMove,
  type ThornState,
} from './logic';

export const thornMode: PuzzleMode<ThornState, ThornMove, ThornConfig> = {
  id: 'thorn',
  name: 'Thorn',
  tagline: 'Trace a path through the letters',
  description:
    'Trace a path through touching letters — around corners, not just straight lines — to spell as many words as you can.',
  accent: 'berry',
  glyph: 'thorn',
  howToPlay: [
    { title: 'Trace a path', body: 'Tap touching letters in a run — across, down, or around a corner. Never reuse a cell.' },
    { title: 'Bank the word', body: 'Tap the last letter again, or press Submit. Clear to start a new trace.' },
    { title: 'Hit the target', body: 'Reach the word target, or finish any time to bank what you traced.' },
  ],
  difficulties: THORN_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove,
  moveFeedback,
  handleKey,
  hint,
  score,
  summarize,
  serialize: (s) => s,
  deserialize,
  Board: ThornBoard,
};
